module.exports = __webpack_public_path__ + "img/flag-regular.10ae6a25.svg";